import React from "react";
import { SUMMARY, EDUCATION, PROFILE } from "@/data/portfolio";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="bg-background">
      <div className="max-w-3xl mx-auto px-6 py-10">
        <hr className="rule" />
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-4">
          About
        </h2>

        <p className="text-base md:text-lg text-foreground/85 leading-relaxed">
          {SUMMARY}
        </p>

        <div className="mt-10" data-testid="education-block">
          <h3 className="font-serif text-xl text-foreground mb-2">Education</h3>
          <p className="text-base text-foreground/85 leading-relaxed">
            <strong className="font-medium">{EDUCATION.degree}</strong>
            <br />
            {EDUCATION.school}, {EDUCATION.university}
            <br />
            <span className="text-quiet text-sm">
              {EDUCATION.period} &middot; CGPA {EDUCATION.cgpa}
            </span>
          </p>
        </div>

        <div className="mt-10">
          <h3 className="font-serif text-xl text-foreground mb-2">Contact</h3>
          <p className="text-base text-foreground/85 leading-relaxed">
            Based in {PROFILE.location}. The fastest way to reach me is{" "}
            <a
              href={PROFILE.socials.email}
              data-testid="about-email-link"
              className="link"
            >
              {PROFILE.email}
            </a>{" "}
            or{" "}
            <a
              href={`tel:${PROFILE.phone.replace(/\s+/g, "")}`}
              data-testid="about-phone-link"
              className="link"
            >
              {PROFILE.phone}
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
};
